import van, { type ChildDom } from "vanjs-core";
import { locale } from "../locale";
import {
	sortedSetAdd,
	sortedSetDelete,
	sortedSetIncludes,
} from "../sorted_set";
import { state } from "../state";
import { materialSymbol } from "./material-symbol";
import { button, div, input, label, span } from "./van-tags";

interface TagsFieldParams {
	getTags: () => string[];
	setTags: (tags: string[]) => void;
}

function isReservedTag(tag: string): boolean {
	const productTags = [
		"FarmCam SIM",
		"FenceAlarm",
		"FenceAlarm2",
		"SmartPlug",
		"SmartPlug2",
	];
	if (productTags.includes(tag)) return true;

	// Check if email
	return /.+@.+\..+/.test(tag);
}

function selectedDeviceTagControl(
	args: TagsFieldParams,
	tag: string,
): HTMLDivElement {
	return div(
		{ class: "control" },
		div(
			{ class: "tags has-addons" },
			span({ class: "tag is-primary" }, tag),
			span(
				{ class: "tag" },
				materialSymbol({
					id: "remove",
					onclick: () => {
						args.setTags(sortedSetDelete(args.getTags(), tag));
					},
				}),
			),
		),
	);
}

export function tagsField(args: TagsFieldParams): ChildDom {
	const allTags = van.state(state.getDeviceTags());
	const tag = van.state("");
	return div(
		{ class: "field" },
		label(
			{ class: "label" },
			locale.string({
				enGB: "Tags",
				deDE: "Tags",
				frFR: "Tags",
				svSE: "Taggar",
			}),
		),
		div(
			{ class: "field has-addons" },
			div(
				{ class: "control is-expanded" },
				input({
					class: "input",
					oninput: (e: Event) => {
						if (!(e.target instanceof HTMLInputElement)) return;
						tag.val = e.target.value;
					},
					type: "text",
					value: tag,
				}),
			),
			div(
				{ class: "control" },
				button(
					{
						class: "button is-primary",
						onclick: () => {
							args.setTags(sortedSetAdd(args.getTags(), tag.val));
							allTags.val = sortedSetAdd(allTags.val, tag.val);
							tag.val = "";
						},
					},
					locale.string({
						enGB: "Add",
						deDE: "Hinzufügen",
						frFR: "Ajouter",
						svSE: "Lägg till",
					}),
				),
			),
		),
		() =>
			div(
				{ class: "field is-grouped is-grouped-multiline" },
				allTags.val
					.filter((tag) => !isReservedTag(tag))
					.map((tag) =>
						sortedSetIncludes(args.getTags(), tag)
							? selectedDeviceTagControl(args, tag)
							: unselectedDeviceTagControl(args, tag),
					),
			),
	);
}

function unselectedDeviceTagControl(
	args: TagsFieldParams,
	tag: string,
): HTMLDivElement {
	return div(
		{ class: "control" },
		div(
			{ class: "tags has-addons" },
			span({ class: "tag" }, tag),
			span(
				{ class: "tag" },
				materialSymbol({
					id: "add",
					onclick: () => {
						args.setTags(sortedSetAdd(args.getTags(), tag));
					},
				}),
			),
		),
	);
}
